// Stage-01 stub: the workspace shows a logged-in user (avatar, "my projects",
// shared projects) but the app has no auth yet. We hardcode a single current
// user so created_by / ownership / sharing have something to hang on; real auth
// comes in a later stage. See memory: rights-analysis-rebuild.
export const CURRENT_USER = {
  id: 'dev-user-1',
  name: 'יונתן לוי',
  email: 'yonatan@urbanix.co.il',
  // No avatar image yet — the shell renders initials when this is null.
  avatar: null,
};

export function userInitials(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2);
  return parts[0][0] + parts[parts.length - 1][0];
}

// Map a user id to a display name for "edited by" stamps. Until real accounts
// land this is a tiny local directory; the second entry lets us exercise the
// shared-with-me case in testing. Replace with the account directory later.
export const KNOWN_USERS = {
  'dev-user-1': 'יונתן לוי',
  'dev-user-2': 'רותם בר',
};

export function userName(id) {
  if (!id) return '';
  return KNOWN_USERS[id] || (id === CURRENT_USER.id ? CURRENT_USER.name : '');
}
